
import { kinoParticipants, Video } from "../../libs/roomnew";
export default class MyStage{
    constructor(stage){
        this.stageView=false;
        this.stage=stage;
        //html
        this.remoteVideos=$('#remoteVideos');
        this.mainVideos=$("#remoteVideosContainer");
        this.onStageContainer=null;
        this.onStageParticipants=null;
        this.audienceContainer=null;
    }
    isStageView(){
        return this.stageView;
    };

    startStageView(){
        if(this.isStageView()){
            this.stopStageView();
            return
        }
        let stageTitle=$("<span/>",{
            html:"Stage"
        })
        let stageTitleContainer=$("<div/>",{
            class:"on-stage-title-container",
            html:[stageTitle]
        });
        this.onStageVideoList=$("<div/>",{
            class:"on-stage-video-list"
        });
        this.onStageVideoScrollable=$("<div/>",{
            class:"on-stage-video-scrollable",
            html:[this.onStageVideoList]
        }).on('wheel',(event)=>{
            event.preventDefault();
            this.onStageVideoScrollable.animate({scrollLeft:this.onStageVideoScrollable.scrollLeft() + event.originalEvent.deltaY},30);
        });
        let onstageVideowrapper=$("<div/>",{
            class:"on-stage-video-wrapper",
            html:[stageTitleContainer,this.onStageVideoScrollable]
        });
        this.onStageContainer=$("<div/>",{
            class:"on-stage-container",
            html:[onstageVideowrapper]
        });

        //audience
        this.audienceTitle=$("<span/>",{
            html:"Audience"
        });
        let audienceTitleContainer=$("<div/>",{
            class:'on-stage-audience-title-container',
            html:this.audienceTitle
        })
        this.audienceScrollable=$("<div/>",{
            class:"on-stage-audience-scrollable"
        });
        this.audienceVideosWrapper=$("<div/>",{
            class:"on-stage-audience-wrapper",
            html:[audienceTitleContainer,this.audienceScrollable]
        });
        this.audienceContainer=$("<div/>",{
            class:"on-stage-audience-container",
            html:[this.audienceVideosWrapper]
        });
        this.mainVideos.appendTo(this.audienceScrollable);
        this.remoteVideos.addClass("on-stage-view");

        this.remoteVideos.append([this.audienceContainer,this.onStageContainer]);

        this.stageView=true;
        this.addMyVideoOnStage();
        Video.disableToggle();
        setTimeout(() => {
            Video.efss.inViewPortAudienceVideos();
            this.audienceScrollable.scroll(Video.efss.inViewPortAudienceVideos.bind(Video.efss));
        }, 1000);
    };

    stopStageView(){
        this.moveStageVideosToMain();
        this.addMyVideoOnMainScreen();
        this.onStageContainer.remove();
        this.mainVideos.appendTo(this.remoteVideos);
        this.audienceContainer.remove();
        this.remoteVideos.removeClass("on-stage-view");
        this.audienceScrollable=null;
        this.audienceVideosWrapper=null;

        this.onStageVideoList=null;
        this.onStageVideoScrollable=null;
        this.stageView=false;
        this.isPresenting=null;

        Video.resizeMainVideos();
        Video.enableToggle();
    };

    addParticipantsOnStage(pids){
        pids.forEach(pid => {
            if(Video.videos[pid]){
                let size=this.getVideoSize();
                Video.videos[pid].viewContainer.appendTo(this.onStageVideoList).css({width:size.width+"px",height:size.height+"px"});
                delete Video.mainParticipants[pid];
                delete Video.sideParticipants[pid];
            }
        });
        Video.resizeMainVideos();

    };

    removeParticipantVideoFromStage(pid){
        // this.sta.participants=this.participants.filter(id=>id!=pid);
        Video.moveVideoToMain(pid);
        Video.resizeMainVideos();
    };

    addMyVideoOnStage(){
        $('#app').removeClass('local-minimized');
        let size=this.getVideoSize();
        Video.localVideo.viewContainer.appendTo(this.onStageVideoList).css({width:size.width+"px",height:size.height+"px"});
        Video.localVideo.minimize.attr('title', 'Minimize');
        Video.localVideo.minimize.attr('data-original-title', 'Minimize');
        // app.localVideo.minimize.tooltip('hide');
        Video.localVideo.minimize.html(app.minimizeIcon);
        Video.isLocalMaximized = true;
        Video.nonDraggableVideo();
        Video.resizeMainVideos();
    };

    addMyVideoOnMainScreen(){
        Video.localVideo.viewContainer.appendTo(Video.remoteVideosContainer);
        Video.localVideo.minimize.attr('title', 'Minimize');
        Video.localVideo.minimize.attr('data-original-title', 'Minimize');
        // app.localVideo.minimize.tooltip('hide');
        Video.localVideo.minimize.html(app.minimizeIcon);
        Video.isLocalMaximized = true;
        Video.nonDraggableVideo();
        Video.resizeMainVideos();
    };

    moveStageVideosToMain(){
        this.onStageVideoList.find('.videoViewContainer').each((index,el)=>{
            // console.log("on stage video",el)
            if($(el).attr('id')!="localParticipant"){
                Video.moveVideoToMain($(el).attr('id'));
            }
        })
    };

    getVideoSize(){
        let availableHeight=this.onStageVideoScrollable.height() - 10;
        let ratio=16/9;
        let availableWidth=Math.ceil(availableHeight*ratio);

        return {
            width: availableWidth,
            height: availableHeight
        };
    };

    moveAudienceToSide(){
        kinoParticipants.addAllInSideScreen(this.stage.participants);
    };
    moveAudienceToMain(){
        kinoParticipants.moveAllToMain(this.stage.participants);
    };
    movePresenterToMain(pid){
        if(Video.videos[pid]){
            Video.moveVideoToMain(pid);
            Video.resizeMainVideos();
        }
    }
    switchToPresenterView(){
        this.onStageContainer.addClass("on-stage-presenting");
        this.audienceContainer.addClass("on-stage-presenting");
        $("#sideVideos").prepend($("<div/>",{
            html:"Audience",
            class:'side-audience-title'
        }));
        this.moveAudienceToSide();
        this.audienceTitle.html("Presenting");
        this.resizeStageVideos();
    };

    switchToAudienceView(){
        this.onStageContainer.removeClass("on-stage-presenting");
        this.audienceContainer.removeClass("on-stage-presenting");
        $("#sideVideos").find('.side-audience-title').remove();
        if(this.isPresenting){
            this.addParticipantsOnStage([this.isPresenting]);
        }
        this.moveAudienceToMain();
        Video.resizeMainVideos();
        this.isPresenting=null;
        this.audienceTitle.html("Audience");
        this.resizeStageVideos();
    };
    resizeStageVideos(){
        if(!this.isStageView()){
            return;
        }
        let size=this.getVideoSize();
        if(this.onStageVideoList){
            this.onStageVideoList.find('.videoViewContainer').css({
                width:size.width+"px",
                height: size.height+"px"
            });
        }
    }
    switchPresenters(newPresenter){
        if(this.isPresenting){
            this.addParticipantsOnStage([this.isPresenting]);
        }
        this.setPresenter(newPresenter);
    };

    setPresenter(pid){
        this.isPresenting=pid;
        this.switchToPresenterView();
        this.movePresenterToMain(pid);
    };

};
